import { render, staticRenderFns } from "./OnboardingPackagesTab.vue?vue&type=template&id=d4a59f4a&"
import script from "./OnboardingPackagesTab.vue?vue&type=script&lang=js&"
export * from "./OnboardingPackagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports